import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useDeleteUserMutation } from '../../../../api/users'
import { extractApiErrorMessage, logOut } from '../../../../utils/api'
import { SettingsSectionShell } from './SettingsSectionShell'

type Props = {
  userId: number
}

export const AccountDangerSection = ({ userId }: Props) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation()

  const handleConfirmDelete = async () => {
    try {
      await deleteUser({ userId }).unwrap()
      setIsDeleteModalOpen(false)
      toast.success('Профиль удалён')
      await logOut()
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? 'Не удалось удалить профиль')
    }
  }

  return (
    <>
      <SettingsSectionShell
        title="Аккаунт"
        description="Здесь находятся необратимые или чувствительные действия аккаунта. Они не меняют ваши настройки приватности и уведомлений."
      >
        <Card variant="primaryAdaptiveCard" sx={{ p: 2.5 }}>
          <Stack gap={1.5}>
            <Typography variant="black-16-semiBold">Опасная зона</Typography>
            <Typography variant="black-14-normal" color="text.secondary">
              Удаление профиля скроет ваш аккаунт из списка людей. Комментарии и другой контент останутся с пометкой
              «Удалённый аккаунт». Войдите снова, чтобы восстановить аккаунт.
            </Typography>
            <Stack direction="row">
              <Button variant="danger" onClick={() => setIsDeleteModalOpen(true)}>
                Удалить профиль
              </Button>
            </Stack>
          </Stack>
        </Card>
      </SettingsSectionShell>

      <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
        <DialogTitle>Удалить профиль</DialogTitle>
        <DialogContent>
          <Typography variant="black-14-normal">
            Профиль будет скрыт из поиска и списка людей. Сессия завершится — для восстановления нужно будет снова войти с этим email.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="follow" onClick={() => setIsDeleteModalOpen(false)} disabled={isDeleting}>
            Отмена
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete} disabled={isDeleting}>
            {isDeleting ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                <CircularProgress size={16} color="inherit" />
                <span>Удаление...</span>
              </Stack>
            ) : (
              'Удалить'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
